import decode from "jwt-decode"
import baseurl from "../../configurations/baseurl/baseurl"
import * as ers from "../../errorsmessages/errors"
import * as rt from "../../routes/routes"
import router from "../../router"

export default class AuthService {
  loggedIn() {
    var token = localStorage.getItem('id_token')
    var expiration = localStorage.getItem('expiration')
    if (!token || !expiration) {
      return null
    }

    if (Date.now() > parseInt(expiration, 15)) {
     
      return false
    } else {
      return token
    }
  }

  isTokenExpired(expiration) {
    localStorage.setItem('expiration', expiration)
  }

  setToken(Token) {
    localStorage.setItem('id_token', Token)
  }

  getToken() {
    return localStorage.getItem('id_token')
  }

  isLoggedIn()
  {
    
    if(this.getToken())
    {
      return true;
        
    }
    else {
      return false;
    }
  }

  logout() {
    localStorage.clear()
    router.push('/login')

    // baseurl
    //   .get(rt.userLogout)
    //   .then(res => {
    //     if (res.data.code === 200) {
    //       localStorage.clear()
    //       router.push('/login')
    //     } else if (res.data.code === 404) {
    //       ers.errorLoginOutUser()
    //     }
    //   })
  }

  setuserRoleModules(rolemodules) {
    localStorage.setItem('rm', rolemodules)
  }
  
  

  setUsername(username) {
    localStorage.setItem('username', username)
  }

  setprofile(pic) {
    localStorage.setItem('pic', pic)
  }
  
}



// WEBPACK FOOTER //
// ./src/configurations/authentications/auth.js